export default "/images/SimayCelikel.jpg?30ee65068f28b46095ad6f4b3c7d46fb";